import { type DragEvent } from 'react';
import { isFirefox } from 'react-device-detect';

const BlankIcon =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/**
 * Whether the current browser supports the APIs necessary for our custom
 * "drag preview" element movement
 */
// Firefox does not report pageX/pageY on drag events, but has a native drag
// preview, which is usually sufficient.
export const supportsDragPreview = !isFirefox;

/**
 * Replaces the native browser drag preview with a blank pixel so that a
 * custom preview can be rendered instead. (skipped on some browsers
 * @see supportsDragPreview)
 */
export function suppressNativeDragPreview(e: DragEvent<HTMLElement>): void {
    if (!supportsDragPreview || !e.nativeEvent.target) {
        return;
    }
    const dragIcon = document.createElement('img');
    dragIcon.src = BlankIcon;
    dragIcon.width = 0;
    dragIcon.height = 0;
    e.dataTransfer.setDragImage(dragIcon, -10, -10);
}
